import Vue from 'vue'
import BootsrapVue from 'bootstrap-vue';
import moment from 'moment';
import VueCompositionAPI from '@vue/composition-api'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import VueApexCharts from 'vue-apexcharts';
import VueSwal from 'vue-swal';
import VModal from 'vue-js-modal';

import router from './router'
import store from './store'
import App from './App.vue'
import TerminologyService from '@/services/TerminologyService';

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// import assets styles
require('@/assets/scss/style.scss')

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(VueApexCharts);
Vue.use(VueSwal);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });
Vue.component('apexchart', VueApexCharts);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

extend('after_or_equal_date', {
  validate(value, params) {
    const { startDate } = params;
    return new Date(value) >= new Date(startDate);
  },
  params: ['startDate'],
  message: 'The end date must be after or equal to the start date.',
});

// BSV Plugin Registration
Vue.use(BootsrapVue)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.filter('formatDate', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY');
});

Vue.filter('formatDateTime', value => {
  if (!value) return '';
  return moment(String(value)).format('DD/MM/YYYY HH:mm');
});

Vue.filter('formatTime', value => {
  if (!value) return '';
  return moment(String(value)).format('HH:mm');
})

Vue.filter('capEachWord', value => {
  if (!value) return '';
  return value
    .toLowerCase()
    .split(' ')
    .map(s => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
});

Vue.filter('boolToYes', value => (value ? 'Yes' : 'No'));

Vue.filter('formatDateAge', value => {
  if (!value) return '';
  return moment(new Date()).diff(value, 'years');
});

Vue.filter('term', (word, capitalize = false) => {
  const { user } = store.state.auth;
  const establishment = user ? user.prison.establishment_type : 'prison';

  if (!word) return '';

  if (word === 'prison') {
    return TerminologyService.getEstablishmentTextForPrison(establishment, capitalize);
  } else if (word === 'prisoner') {
    return TerminologyService.getEstablishmentTextForPrisoner(establishment, capitalize);
  }
});

Vue.filter('regionCurrency', () => {
  let region = store.state.region || 'UK';

  if (region === 'UK'){
    return '£';
  }
  return '$'; // Australia
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
